const ParticleCanvas = () => {
  return <canvas id="particles-canvas"></canvas>;
};

export default ParticleCanvas;
